var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchShine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 527,
    viewBox: "0 0 287 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_202_10421",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 287,
    height: 527
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 526.897H286.371L202.033 -7.90146e-06H93.1283L0 526.897Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_202_10421)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 289.976,
    height: 605.334,
    transform: "matrix(1 0 0 -1 -2.19385 553.47)",
    fill: "url(#pattern0_202_10421)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_202_10421",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_202_10421",
    transform: "scale(0.0135135 0.00847458)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_202_10421",
    width: 74,
    height: 118,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAB2CAYAAABvaAWnAAAAAXNSR0IArs4c6QAABOVJREFUeF7tnOuWqzAIhfX9X3lOPatjdbQmgc0lBFt/jkA2XyBJ1TXzz/JYpu9FEpi9QM3TNKWYgafIp1jicgNFDRxynwmlpO2zQClmRwdKMUNFzVQ86r4CBOVKg2qJCxROJWZ9nwZ1GTHNMi1nVSgAASj5+Ov2kmIvvJbHz+OxnLbHDO3kpLE1jb8Vhc0zZq2pP3vfinYGeKL18kBBlcL2Xidz+2ooR0QTluqCFvNeoqTJePpBoDyFjBK7VgzmoKKrzmt8c1CjVMaq44XtuKsxdrjKj+JloQ6B2Cxh1mOBPas5ZnLzirLbKV1AYTW1WWNevSvRBVTvJNrj2UwAC1RxKOGiOBZEvhoa1IcBqa1qNCg+9FtbOoGyWRd6kOcqdQKV+RFdpfl+FvrA2WNmRx/DraKwxLkNgEW1tB4E1CElzi7LsZFSqsQeD9TfT9n1JyjjdbeUyebHqecwUHVxHNlaNLj//G95PFfzoa+u6DK1XnXWOrVi+XnU+3s9VW05zH0gnCMK7L1ekGgUf/NFJvGu2vmZOZqKqmwdnGn9Ybseni2dDB6T71EAFSuIL72vZaKK0oHRntt2UHsg6YIt9TuexHUsZN5M3TgoVmBJ+0p8ZGyQny67bc6PNByhpjuZsyq3VlESkG2fNIu5JHVdY569Y0CpqsUyfUasl1Y9qExJM7hUm7m8mEcXuiIjJ9e1ooCq+FSE+tZrziATKzBRkoJhqmhncmk9c9EWMiV4bH0CKkoOTu6ph+YMSi9wlAgnUNSMUfdHScpDx6Wiqo9C3x6hbnYh8MzXURqtuvVCQNF5mVuoQZkrkgZ0rrKcoDYob3A8qzsnKGnVNfxWyC/UheosgvKcGYccu4RUVBSBc/ug4Wk2/EWXhgLU8NnLBXJbb32aQFPmK5mneVofUmS6jgSSVNQK+nlZwkZKwQ8U61yDSI2txQOosui/v+ZJSoa0nSn22Q9XAauaiG/RWzGY8Xe5qH0hz0br3b2CuLO+2tmuUQYzh8nvZ80DZQWgFscqviO3b+sx4X5BiUEp2wDbAjBrZk4uZrw1ah86T2LWtGhQygrjCR5tAq56aFC8TJ2s+gGkRhoclBN/QVgGKIp1bVSpXzne9vzP8ukBwssRFFeGLVDuqKgd9KYYDR5rz5iAw0ZFWbPfFMcmvY1OpeOnktF6xODV40NcUh649KBKqrqcvTxw1GP6gOqbg3g0pOZNQCEDirMKdjQBFZzDYXhkyhBb6yec4xAzUnJ44bB97IrxtdEhHVPqp1Etbr0IsZpE2750Ng7/IIIeVJuwaATlkUVcUdpks/njoJQzMyQgRk44qFOmOb9SkUyWElTjyG/85ck+EmP2JSAoHzdQ8b/3qdSx+2agRDsRpjXU2gxUOYv74GuDcl8PbEFaRnuPJawoWhJtEdpJ8OBCUPA44zgIu4QBKvpF0RiMGaDGEFpUIawOSUa5QQkf2QWButuyXTnoSP/bTxVPx3ZA/l+DpIqOPmlaz7du6Q2rE6h6mjYASlF4kXlW35cLREcWXi5oe9jLnzvjXuPvT0Gki7m3MLP4RpvLdY0yCmyW6CCBhvzsJ67dGptOeOslqWCD40Hc/PfsSgNQZ7me2DxjU9APoCJlUDLX+yYKha2OVZRwkCuGcsomIHjMYSsMFBz+Pg6pQfWswNSgetbrf/hcwOa7ME3BAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchShine);
export default __webpack_public_path__ + "static/media/launch-shine.4f6667dfdfb142f6e47743fb17847df7.svg";
export { ForwardRef as ReactComponent };